import { lazy } from 'react';

export { Contract } from './contract';

export const LazyContract = lazy(() => import('./contract').then((mod) => ({ default: mod.Contract })));
